webpackJsonp([16550220580097],{

/***/ 122:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGFhZ18xIiBkYXRhLW5hbWU9IkxhYWcgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjU2LjQ5IDI1Ny45OSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMDNkMjQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT4xNzEwMDVfUm9iaW52YW5XZWNoZW1fV2Vic2l0ZV9JY29uczwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTU3LjI3LDY5LjQ0VjMwLjM1SDEyMy4wOGMtMTYuNjMsMC0zMi4zOSwzLjE4LTQzLjIzLDguNzJsLTMuOTQsMiwxNC43LDEyLjMzLDEuOTItLjcyYzcuNjEtMi44MSwxNy4zMy00LjQ2LDI3LjYyLTQuNzNWNjkuNDRhNDIsNDIsMCwwLDAtMjMuNDQsMzcuNjhWMjI3LjY0aDg0VjEwNy4xMmE0Miw0MiwwLDAsMC0yMy40NC0zNy42OFpNOTEuNzcsNDYuNzRsLTUuMTUtNC4zMmM5Ljc2LTQsMjIuNzUtNi4yMSwzNi40Ni02LjIxaDI4LjMyVjU2LjkySDEyNlY0Mi4wN2gtMi45M2MtMTEuNDgsMC0yMi41MywxLjY1LTMxLjMxLDQuNjdabTEwLjgsNjAuMzdBMzYuMTUsMzYuMTUsMCwwLDEsMTI0LjI2LDc0bDEuNzYtLjc3VjYyLjc4aDkuNzd2NjcuNTlIMTAyLjU3Wm03Mi4yNywxMTQuNjZIMTAyLjU3VjEzNi4yMmg3Mi4yN1ptMC05MS40MUgxNDEuNjRWNjIuNzhoOS43N1Y3My4yMmwxLjc2Ljc3YTM2LjE1LDM2LjE1LDAsMCwxLDIxLjY4LDMzLjEzWm0wLDAiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik04NS43OCw3MC4zNiw3NS40Miw2MCw2NS4wNyw3MC4zNmExNC42NSwxNC42NSwwLDEsMCwyMC43MiwwWk04MS42NCw4Ni45M0E4Ljc5LDguNzksMCwwLDEsNjkuMjEsNzQuNWw2LjIyLTYuMjIsNi4yMSw2LjIyYTguNzksOC43OSwwLDAsMSwwLDEyLjQzWm0wLDAiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjEzNS43OCIgeT0iMTY3Ljg2IiB3aWR0aD0iNS44NiIgaGVpZ2h0PSI1Ljg2Ii8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxMjQuMDYiIHk9IjE2Ny44NiIgd2lkdGg9IjUuODYiIGhlaWdodD0iNS44NiIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMTQ3LjUiIHk9IjE2Ny44NiIgd2lkdGg9IjUuODYiIGhlaWdodD0iNS44NiIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMTE4LjIiIHk9IjE4Ny40IiB3aWR0aD0iNS44NiIgaGVpZ2h0PSI1Ljg2Ii8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxNDEuNjQiIHk9IjE4Ny40IiB3aWR0aD0iNS44NiIgaGVpZ2h0PSI1Ljg2Ii8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxMjkuOTIiIHk9IjE4Ny40IiB3aWR0aD0iNS44NiIgaGVpZ2h0PSI1Ljg2Ii8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxNTMuMzYiIHk9IjE4Ny40IiB3aWR0aD0iNS44NiIgaGVpZ2h0PSI1Ljg2Ii8+PC9zdmc+"

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGFhZ18xIiBkYXRhLW5hbWU9IkxhYWcgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjU2LjQ5IDI1Ny45OSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMDNkMjQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT4xNzEwMDVfUm9iaW52YW5XZWNoZW1fV2Vic2l0ZV9JY29uczwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTMxLjU3LDIxMy42MWEzLjMzLDMuMzMsMCwxLDEtMy4zMy0zLjMyLDMuMzMsMy4zMywwLDAsMSwzLjMzLDMuMzJabTAsMCIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTEyOC4yNCwxNjYuMjNjMzEuODMsMCw1Ny43Mi0yOS45LDU3LjcyLTY2LjY0cy0yNS44OS02Ni42NC01Ny43Mi02Ni42NFM3MC41Miw2Mi44NCw3MC41Miw5OS41OWMwLDMwLjYzLDE4LDU2LjUsNDIuNDIsNjQuMjZ2NTEuMDhhMTUuMywxNS4zLDAsMSwwLDMwLjYsMFYxNzdhMy4zMywzLjMzLDAsMSwwLTYuNjUsMHYzOGE4LjY1LDguNjUsMCwxLDEtMTcuMjksMFYxNjUuNDhhNTAuNDEsNTAuNDEsMCwwLDAsOC42NS43NVpNNzcuMTcsOTkuNTljMC0zMy4wOCwyMi45MS02MCw1MS4wNy02MHM1MS4wNywyNi45MSw1MS4wNyw2MC0yMi45MSw2MC01MS4wNyw2MC01MS4wNy0yNi45MS01MS4wNy02MFptMCwwIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTI4LjI0LDQ3LjQ1Yy0yMy44LDAtNDMuMTYsMjMuMzktNDMuMTYsNTIuMTRzMTkuMzYsNTIuMTQsNDMuMTYsNTIuMTQsNDMuMTUtMjMuMzksNDMuMTUtNTIuMTRTMTUyLDQ3LjQ1LDEyOC4yNCw0Ny40NVptMCw5Ny42M2MtMjAuMTMsMC0zNi41LTIwLjQxLTM2LjUtNDUuNDlzMTYuMzctNDUuNDksMzYuNS00NS40OSwzNi41LDIwLjQxLDM2LjUsNDUuNDktMTYuMzgsNDUuNDktMzYuNSw0NS40OVptMCwwIi8+PC9zdmc+"

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"src-components-BlockList----index-module---list---19jrn","item":"src-components-BlockList----index-module---item---39Wr5","title":"src-components-BlockList----index-module---title---2z9uB src-global-styles----content---title---1yv3A","date":"src-components-BlockList----index-module---date---u5aJZ src-global-styles----content---title---1yv3A","text":"src-components-BlockList----index-module---text---1jvzK src-global-styles----content---textSerif---2B2hn","textLarge":"src-components-BlockList----index-module---textLarge---3V5NE src-global-styles----content---textSerif---2B2hn","image":"src-components-BlockList----index-module---image----p0eU","link":"src-components-BlockList----index-module---link---23WxT","linkMargin":"src-components-BlockList----index-module---linkMargin---1oR0m src-components-BlockList----index-module---link---23WxT"};

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _indexModule = __webpack_require__(49);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _shampoo = __webpack_require__(122);
	
	var _shampoo2 = _interopRequireDefault(_shampoo);
	
	var _tomaat = __webpack_require__(124);
	
	var _tomaat2 = _interopRequireDefault(_tomaat);
	
	var _spiegel = __webpack_require__(123);
	
	var _spiegel2 = _interopRequireDefault(_spiegel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DilemmaList = function (_React$Component) {
	  _inherits(DilemmaList, _React$Component);
	
	  function DilemmaList() {
	    _classCallCheck(this, DilemmaList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DilemmaList.prototype.render = function render() {
	    var items = this.props.items;
	    var images = {
	      "spiegel": _spiegel2.default,
	      "tomaat": _tomaat2.default,
	      "shampoo": _shampoo2.default
	    };
	    return _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.list },
	      items && items.map(function (item) {
	        return _react2.default.createElement(
	          "article",
	          { key: item.slug, className: _indexModule2.default.item },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: item.slug ? "/boek/" + item.slug : "#" },
	            item.type && _react2.default.createElement("img", { className: _indexModule2.default.image, src: images[item.type], width: "200", height: "200" }),
	            item.title && _react2.default.createElement(
	              "h1",
	              { className: _indexModule2.default.title },
	              item.title
	            )
	          ),
	          item.slug && _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: _indexModule2.default.link, to: "/boek/" + item.slug },
	            "Lees meer"
	          )
	        );
	      })
	    );
	  };
	
	  return DilemmaList;
	}(_react2.default.Component);
	
	exports.default = DilemmaList;
	module.exports = exports["default"];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _indexModule = __webpack_require__(305);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReviewList = function (_React$Component) {
	  _inherits(ReviewList, _React$Component);
	
	  function ReviewList() {
	    _classCallCheck(this, ReviewList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ReviewList.prototype.render = function render() {
	    var items = this.props.items;
	    return _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.list },
	      items && items.map(function (item) {
	        return _react2.default.createElement(
	          "article",
	          { key: item.id, className: _indexModule2.default.item },
	          item.text && _react2.default.createElement(
	            "div",
	            { className: _indexModule2.default.text },
	            item.text
	          ),
	          item.source && _react2.default.createElement(
	            "div",
	            { className: _indexModule2.default.source },
	            item.source
	          )
	        );
	      })
	    );
	  };
	
	  return ReviewList;
	}(_react2.default.Component);
	
	exports.default = ReviewList;
	module.exports = exports["default"];

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"src-components-ReviewList----index-module---list---3r2kB","item":"src-components-ReviewList----index-module---item---3v1CI","text":"src-components-ReviewList----index-module---text---ElXp6 src-global-styles----content---textSerif---2B2hn","source":"src-components-ReviewList----index-module---source---1i6q4 src-global-styles----content---title---1yv3A"};

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.bookPageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _Markdown = __webpack_require__(20);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _DilemmaList = __webpack_require__(206);
	
	var _DilemmaList2 = _interopRequireDefault(_DilemmaList);
	
	var _ReviewList = __webpack_require__(207);
	
	var _ReviewList2 = _interopRequireDefault(_ReviewList);
	
	var _propTypes = __webpack_require__(6);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _indexModule = __webpack_require__(312);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  data: PropTypes.object.isRequired
	};
	
	var Boek = function (_React$Component) {
	  _inherits(Boek, _React$Component);
	
	  function Boek() {
	    _classCallCheck(this, Boek);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Boek.prototype.render = function render() {
	    var content = this.props.data.page.edges[0].node;
	
	    var book = content.book ? content.book[0] : false;
	    var bookPreview = book.preview && book.preview.file.url ? book.preview.file.url : false;
	    var dilemmas = content.dilemmas ? content.dilemmas : false;
	    var reviews = book.reviews ? book.reviews : false;
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement(
	          "title",
	          null,
	          content.title
	        ),
	        _react2.default.createElement("meta", { name: "description", content: content.metaDescription }),
	        _react2.default.createElement("meta", { property: "og:title", content: content.title }),
	        _react2.default.createElement("meta", { property: "og:description", content: content.metaDescription })
	      ),
	      content.body && _react2.default.createElement(_Markdown2.default, { className: _indexModule2.default.article, source: content.body.body }),
	      book && _react2.default.createElement(
	        "section",
	        { className: _indexModule2.default.book },
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.coverContainer },
	          book.cover && _react2.default.createElement("img", {
	            className: _indexModule2.default.cover,
	            src: book.cover.file.url + "?w=300",
	            srcSet: "\n                    " + book.cover.file.url + "?w=300 300w,\n                    " + book.cover.file.url + "?w=410 410w,\n                    " + book.cover.file.url + "?w=615 615w,\n                    " + book.cover.file.url + "?w=820 820w\n                  ",
	            width: "410"
	          }),
	          bookPreview && _react2.default.createElement(
	            "a",
	            { className: _indexModule2.default.bookPreviewLink, href: book.preview.file.url, target: "_blank" },
	            "Neem een kijkje in het boek"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.bookContent },
	          book.title && _react2.default.createElement(
	            "h1",
	            { className: _indexModule2.default.bookTitle },
	            book.title
	          ),
	          book.body.body && _react2.default.createElement(_Markdown2.default, { className: _indexModule2.default.article, source: book.body.body }),
	          _react2.default.createElement(
	            "div",
	            { className: _indexModule2.default.bookDetails },
	            book.isbn && _react2.default.createElement(
	              "div",
	              { className: _indexModule2.default.bookDetailItem },
	              "ISBN: ",
	              book.isbn
	            ),
	            book.price && _react2.default.createElement(
	              "div",
	              { className: _indexModule2.default.bookDetailItem },
	              "Prijs: ",
	              book.price
	            ),
	            book.publisher && _react2.default.createElement(
	              "div",
	              { className: _indexModule2.default.bookDetailItem },
	              "Uitgever: ",
	              book.publisher
	            )
	          ),
	          book.orderLink && _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: _indexModule2.default.bookLink, to: book.orderLink },
	            "Bestel het boek"
	          )
	        )
	      ),
	      dilemmas && _react2.default.createElement(
	        "section",
	        { className: _indexModule2.default.dilemma },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Badkamerdilemma's"
	        ),
	        _react2.default.createElement(_DilemmaList2.default, { items: content.dilemmas })
	      ),
	      reviews && _react2.default.createElement(
	        "section",
	        { className: _indexModule2.default.reviews },
	        _react2.default.createElement(_ReviewList2.default, { items: reviews })
	      )
	    );
	  };
	
	  return Boek;
	}(_react2.default.Component);
	
	Boek.propTypes = propTypes;
	
	exports.default = Boek;
	var bookPageQuery = exports.bookPageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"book":"src-pages-boek----index-module---book---2UImk src-global-styles----content---content---2NlNu src-global-styles----content---maxWidth---6eZ_6","coverContainer":"src-pages-boek----index-module---coverContainer---3rUVr","cover":"src-pages-boek----index-module---cover---2Y6-_","bookContent":"src-pages-boek----index-module---bookContent---avRs8","bookTitle":"src-pages-boek----index-module---bookTitle---2_LDK","bookText":"src-pages-boek----index-module---bookText---3vaZ0","bookDetails":"src-pages-boek----index-module---bookDetails----rwZq","bookDetailItem":"src-pages-boek----index-module---bookDetailItem---Y5B8C","bookLink":"src-pages-boek----index-module---bookLink---3ahXd","bookPreviewLink":"src-pages-boek----index-module---bookPreviewLink---3_GRB","dilemma":"src-pages-boek----index-module---dilemma---3Hbgr","reviews":"src-pages-boek----index-module---reviews---3lJX2 src-global-styles----content---content---2NlNu src-global-styles----content---maxWidth---6eZ_6"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-boek-index-js-818673e6c0f53e97dc78.js